import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.53 11.47 10 16.94 20.47 6.47a.75.75 0 1 1 1.06 1.06l-11 11a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06"
  }));
}
var IcDone = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDone));

export { IcDone as I };
